import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import {
  NodeConfigurationResult,
  NodeConfigurationPanelActions,
  NodeConfigurationPanelActionTypes
} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {cloneDeep} from "lodash";

export function nodeConfigurationPanelState(state = initialState.nodeConfigurationPanelState, action: NodeConfigurationPanelActions) {
  let newState: Map<string, NodeConfigurationResult> = cloneDeep(state);

  switch (action.type) {
    case NodeConfigurationPanelActionTypes.INITIAL_DATA:
      newState.set(action.type, action.payload);
      return newState;

    case NodeConfigurationPanelActionTypes.UPDATED_DATA:
      newState.set(action.type, action.payload);
      return newState;

    case NodeConfigurationPanelActionTypes.CLEAR_DATA:
      newState.clear();
      return newState;

    default:
      return state;
  }
}
